import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Seo from '@/components/seo/Seo';

export default function CorporateCompletePage() {
  return (
    <>
      <Seo route="/corporate/complete" />
      <Header />
      <main className="pt-[120px]">
      <section className="relative min-h-[80vh] flex items-center justify-center bg-background-50">
        <div className="max-w-[600px] mx-auto px-8 py-20 text-center">
          {/* Success icon */}
          <div className="w-16 h-16 mx-auto mb-8 rounded-full bg-accent-500/10 border border-accent-500/30 flex items-center justify-center">
            <i className="ri-check-line text-accent-500 text-2xl"></i>
          </div>

          <h1 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            お問い合わせを受け付けました
          </h1>
          <div className="gold-line mx-auto mb-6"></div>
          <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed mb-10">
            お問い合わせありがとうございます。担当者より2営業日以内にご連絡いたします。
          </p>
          <p className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed mb-10">
            お急ぎの場合は、お電話{' '}
            <a href="tel:0368244086" className="text-accent-600 hover:text-accent-500 transition-colors">
              03-6824-4086
            </a>
            {' '}（平日 10:00〜17:00）までご連絡ください。
          </p>

          <Link
            to="/corporate"
            className="btn-glow inline-block px-10 py-3.5 bg-accent-500/90 hover:bg-accent-500 text-primary-900 text-[15px] tracking-[0.1em] font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            法人研修ページに戻る
          </Link>
        </div>
      </section>
    </main>
      <Footer />
    </>
  );
}